var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Grid } from 'material-ui';
import EventLog from '../components/EventLog';
import Passengers from '../components/Passengers';
import MapControl from '../components/MapControl';
import AudioComponent from '../components/AudioComponent';
import DoorStatus from '../components/DoorStatus';
import Displays from '../components/Displays';
import { connect } from 'react-redux';
import CustomCard from '../components/CustomCard';
import { VehicleController } from '../components/VehicleController';
import Divider from 'material-ui/Divider';
import TestController from '../containers/TestController';
import TestModeDependentContainer from '../containers/TestModeDependentContainer';
import ModeChooserTabs from '../containers/ModeChooserTabs';
import TelegramSender from '../components/TelegramSender';
var Home = /** @class */ (function (_super) {
    __extends(Home, _super);
    function Home() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Home.prototype.render = function () {
        return (React.createElement(Grid, { container: true },
            React.createElement(Grid, { item: true, xs: 12, md: 6 },
                React.createElement(Grid, { container: true, direction: "column", justify: "space-between" },
                    React.createElement(Grid, { item: true },
                        React.createElement(Displays, null)),
                    React.createElement(Grid, { item: true },
                        React.createElement(CustomCard, null,
                            React.createElement(ModeChooserTabs, null),
                            React.createElement(Grid, { container: true, alignItems: "center" },
                                React.createElement(TestModeDependentContainer, { referenceMode: "test_scenario" },
                                    React.createElement(Grid, { item: true },
                                        React.createElement(TestController, null)),
                                    React.createElement(Grid, { item: true, xs: 12 },
                                        React.createElement(Divider, null))),
                                React.createElement(Grid, { item: true, xs: 12, md: 12 },
                                    React.createElement(VehicleController, null)),
                                React.createElement(Grid, { item: true, xs: 12 },
                                    React.createElement(Divider, null)),
                                React.createElement(Grid, { item: true, xs: 12, md: 6 },
                                    React.createElement(AudioComponent, null)),
                                React.createElement(Grid, { item: true, xs: 12 },
                                    React.createElement(Divider, null)),
                                React.createElement(Grid, { item: true, xs: 12, md: 12 },
                                    React.createElement(DoorStatus, null)),
                                React.createElement(TestModeDependentContainer, { referenceMode: "automated" },
                                    React.createElement(Grid, { item: true, xs: 12 },
                                        React.createElement(Divider, null)),
                                    React.createElement(Grid, { item: true, xs: 12 },
                                        React.createElement(Passengers, null)))))))),
            React.createElement(Grid, { item: true, xs: 12, md: 6 },
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(MapControl, null)),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(TelegramSender, null))),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(EventLog, null))));
    };
    return Home;
}(React.Component));
export default connect()(Home);



//////////////////
// WEBPACK FOOTER
// ./src/pages/Home.tsx
// module id = 1697
// module chunks = 0